import { render, staticRenderFns } from "./MultiSelectorCell.vue?vue&type=template&id=923bec04&scoped=true&"
import script from "./MultiSelectorCell.vue?vue&type=script&lang=js&"
export * from "./MultiSelectorCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923bec04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
